import "./footer.css";

function Footer(){
    return(
        <>
        <div className="footer1">
            <div className="footer">
                <div className="about">
                    <h1><i className="fa-solid fa-phone"></i></h1>
                    <h1>Phone Number</h1>
                    <p>+91- 099446 83774</p>
                </div>
                <div className="address">
                    <h1><i className="fa-solid fa-envelope"></i></h1>
                    <h1>Email</h1>
                    <p>enterprisestgk@gmail.com</p>
                    
                </div>
                <div className="Contact">
                    <a href="https://www.google.com/maps/place/TGK+ENTERPRISES/@11.7572853,78.0483202,17z/data=!3m1!4b1!4m6!3m5!1s0x3babf90ffbfe98a9:0xdcb174a774b5503a!8m2!3d11.7572853!4d78.0505089!16s%2Fg%2F11sk6gsvyv" target="blank">
                        <h1><i className="fa-solid fa-globe"></i></h1>
                    </a>
                    <h1>Office Address</h1>
                    
                    <p>NO. 1/24-14,BANGALORE SALEM BYE PASS ROAD, KOTTAMETTUPATTI VILLAGE OMALUR, Salem, Tamil Nadu 636455</p>
                    <p>Available from : 9.00am to 6.00pm</p>
                    
                    
                </div>
            </div>
            <p>CopyRights@2023.tgkenterprises.All Rights Resevered</p>
        </div>
        
            
        </>
    )
}

export default Footer;